import { Container } from 'aurelia-dependency-injection';
import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';

interface SharedLabel {
	label: string;
}

export function getSharedLabels(): Readonly<{ [name: string]: SharedLabel }> {
	const i18n: I18N = Container.instance.get(I18N);
	return {
		close: {
			label: i18n.tr('clickable-elements.close'),
		},
		cancel: {
			label: i18n.tr('clickable-elements.cancel'),
		},
		edit: {
			label: i18n.tr('clickable-elements.edit'),
		},
		save: {
			label: i18n.tr('clickable-elements.save'),
		},
		notes: {
			label: i18n.tr('clickable-elements.notes'),
		},
	};
}
